import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IonicPage, NavController, NavParams, ActionSheetController, ToastController, Platform, LoadingController, Loading } from 'ionic-angular';

/*
  Generated class for the GlobalProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class GlobalProvider {
  public baseUrl:string = "https://tccvisitorapp.azurewebsites.net/";
  public uploadUrl:string = "https://visitorappadmin.azurewebsites.net/upload/";
  public assetsUrl:string = "../../assets/";
  public loading = this.loadingCtrl.create({
                            content: 'Please wait!.'
                          });

  constructor(
    public http: HttpClient,
    public loadingCtrl: LoadingController,
  ) {
    console.log('Hello GlobalProvider Provider');
  }
}



// WEBPACK FOOTER //
// ./src/providers/global/global.ts